import api from "@core/plugins/api";
import { DatesHelpers, ArrayHelpers } from "@core/helpers";
import { API_DATE_FORMAT_SHORT } from "@core/constants";

const getCalendarSummaryUrl = (start, end) => `/shift/et/calendar-summary?from=${start}&to=${end}`;
const getCalendarShiftsDetailUrl = (start, end) => `/shift/et/calendar-detail?from=${start}&to=${end}`;

export class ShiftsService {
  static async getCalendarSummary({ start, end }) {
    try {
      const startDate = DatesHelpers.getDayjs(start).format(API_DATE_FORMAT_SHORT);
      const endDate = DatesHelpers.getDayjs(end).format(API_DATE_FORMAT_SHORT);
      const response = await api.private.get(getCalendarSummaryUrl(startDate, endDate));
      return ArrayHelpers.ensureArray(response.data);
    } catch (error) {
      throw error;
    }
  }

  static async getCalendarShiftsDetail({ start, end }) {
    try {
      const startDate = DatesHelpers.getDayjs(start).format(API_DATE_FORMAT_SHORT);
      const endDate = DatesHelpers.getDayjs(end).format(API_DATE_FORMAT_SHORT);
      const response = await api.private.get(getCalendarShiftsDetailUrl(startDate, endDate));
      return ArrayHelpers.ensureArray(response.data);
    } catch (error) {
      throw error;
    }
  }
}
